module.exports = __webpack_public_path__ + "static/media/hamburger.db1df2b3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/hamburger.svg
// module id = 881
// module chunks = 1